import { Component, Prop, h, Fragment, State } from '@stencil/core';
import { getTeaserBackground, getAltClass, getLinkColor } from '../../../utils/teaser';
import { Video } from '@src/interfaces/video.model';
@Component({
  tag: 'visa-submarquee',
  styleUrl: './_visa-submarquee.scss',
  shadow: false,
})
export class VisaSubmarquee {
  /**
   * Sub-Marquee Container Props
   */
  @Prop() enabled: boolean;
  @Prop() marqueeID: string;
  //Teaser Props

  @Prop() teaserTheme: string;
  @Prop() teaserAlignment: any;
  @Prop() teaserEyebrowText: any;
  @Prop() teaserHeadline: string;
  @Prop() teaserSubHeadline: string;
  @Prop() headingStyle: string;
  @Prop() hasTransparentTeaser: Boolean;

  //Media Props
  @Prop() videoEnabled: boolean;
  @Prop() mobileImage: any;
  @Prop() mobileImageAlt: any;
  @Prop() desktopImage: any;
  @Prop() desktopImageAlt: any;
  @Prop() videoProps: Video;

  //Link Props
  @Prop() linkStyle: string;
  @Prop() linkColor: string;
  @Prop() linkPropColor: string;
  @Prop() linkType: string;
  @Prop() linkText: string;
  @Prop() linkVal: string;
  @Prop() linkTarget: string;
  @Prop() linkConversion: string;
  @Prop() linkAriaLabel: string;
  @Prop() linkVideoImage: string;
  @Prop() linkVideoTitle: string;
  @Prop() linkVideoImageText: string;
  @Prop() linkVideoLink: string;
  @Prop() linkVideoAriaLabel: string;
  @Prop() linkNoFollow: string;

  //LinkSub Props
  @Prop() linkStyleSub: string;
  @Prop() linkColorSub: string;
  @Prop() linkTypeSub: string;
  @Prop() linkTextSub: string;
  @Prop() linkValSub: string;
  @Prop() linkTargetSub: string;
  @Prop() linkConversionSub: string;
  @Prop() linkAriaLabelSub: string;
  @Prop() linkVideoImageSub: string;
  @Prop() linkVideoTitleSub: string;
  @Prop() linkVideoImageTextSub: string;
  @Prop() linkVideoLinkSub: string;
  @Prop() linkVideoAriaLabelSub: string;

  @Prop() linkNoFollowSub: string;
  @Prop() imageColumnNumber: number = 7;

  //Accessibility Props
  @Prop() accessibility?: any;


  @State() btnColor: string = '';
  @State() backgroundTheme: string = '';
  @State() altClass: string = '';
  @State() theme: string = '';
  @State() isMobileDeviceUsed: boolean;

  private updateLinkProps() {
    this.backgroundTheme = getTeaserBackground(this.teaserTheme);
    if (this.linkPropColor == '') {
      this.linkColor = getLinkColor(this.teaserTheme,this.linkStyle);
    } else {
      this.linkColor = this.linkPropColor;
    }
    this.altClass = getAltClass(this.teaserTheme);
    this.linkColorSub = getLinkColor(this.teaserTheme,this.linkStyle);
  }

  componentWillLoad() {
    this.updateLinkProps();
    this.isMobileDeviceUsed = window.innerWidth < 992;
    window.addEventListener('resize', () => {
      this.isMobileDeviceUsed = window.innerWidth < 992;
    });
  }

  componentWillUpdate() {
    this.updateLinkProps();
  }

  private getMarqueeContentDom = () => {
    getTeaserBackground(this.teaserTheme);
    return <div class={`vs-col-12 vs-px-0 vs-col-lg-${12 - this.imageColumnNumber}`}>
      <div class={`vs-marquee-content-wrapper vs-content-wrapper-padding vs-row vs-no-gutters vs-justify-content-center  vs-${this.backgroundTheme} ${this.hasTransparentTeaser ? 'vs-transparent' : ''} vs-px-2`}
        style={{ background: this.backgroundTheme }}>
        <div class="vs-col-xl-9 vs-px-md-2 vs-px-lg-1 vs-p-xl-3 vs-mt-2 vs-mt-md-0" >
          {this.teaserEyebrowText && (
            <div class={`vs-lead ${this.altClass}`}>{this.teaserEyebrowText}</div>
          )}
          {this.teaserHeadline && (this.headingStyle === 'h1' || !this.headingStyle) &&
            (<h1 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
          {this.teaserHeadline && this.headingStyle === 'h2' &&
            (<h2 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
          {this.teaserHeadline && this.headingStyle === 'h3' &&
            (<h3 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
          {this.teaserHeadline && this.headingStyle === 'h4' &&
            (<h4 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
          {this.teaserHeadline && this.headingStyle === 'blockquote' && (
            <blockquote class={`vs-h2 ${this.altClass} vs-quote-h2`}
                        innerHTML={this.teaserHeadline}>
              {this.teaserSubHeadline && (
                <cite class={`vs-text ${this.altClass} vs-d-block vs-pt-2`}
                      innerHTML={this.teaserSubHeadline}/>
              )}
            </blockquote>
          )}
          {this.teaserSubHeadline && this.headingStyle !== 'blockquote' && (
            <p class={`vs-text ${this.altClass}`} innerHTML={this.teaserSubHeadline}/>
          )}

          {this.linkText &&
            <vs-link
              linkStyle={this.linkStyle}
              buttonColor={this.linkColor}
              linkType={this.linkType}
              linkText={this.linkText}
              linkVal={this.linkVal}
              linkTarget={this.linkTarget}
              linkConversion={this.linkConversion}
              linkAriaLabel={this.linkAriaLabel}
              videoUrl={this.linkVideoLink}
              videoTitle={this.linkVideoTitle}
              imgPath={this.linkVideoImage}
              isNoFollow={this.linkNoFollow}
              hasDarkBg={this.altClass === 'vs-alt' ? 'yes' : 'no'}
            ></vs-link>
          }
          {this.linkTextSub &&
            <vs-link
              linkStyle={this.linkStyleSub}
              buttonColor={this.linkColorSub}
              linkType={this.linkTypeSub}
              linkText={this.linkTextSub}
              linkVal={this.linkValSub}
              linkTarget={this.linkTargetSub}
              linkConversion={this.linkConversionSub}
              linkAriaLabel={this.linkAriaLabelSub}
              videoUrl={this.linkVideoLinkSub}
              videoTitle={this.linkVideoTitleSub}
              imgPath={this.linkVideoImageSub}
              isNoFollow={this.linkNoFollowSub}
              hasDarkBg={this.altClass === 'vs-alt' ? 'yes' : 'no'}
            ></vs-link>
          }
        </div>
      </div>
    </div>
  }

  private getImageDom = () => {
    return <div class={`vs-col-12 vs-px-0 vs-col-lg-${this.imageColumnNumber} ${this.videoProps.videoTitle.length>0? 'vs-submarquee-video-transition':''}`}>
      <vs-media mediaParent="submarquee"
        desktopImage={this.desktopImage}
        mobileImage={this.desktopImage}
        desktopImageAlt={this.desktopImageAlt}
        mobileImageAlt={this.mobileImageAlt}
        videoProps={this.videoProps}
        videoEnabled={this.videoEnabled}
        accessibility={this.accessibility}
      ></vs-media>
    </div>
  }

  render() {
    return (
      <div id={this.marqueeID}
        class={`vs-submarquee vs-container-fluid ${!this.enabled ? 'vs-d-none' : ''}`}>
        <div class="vs-row">
          {!this.isMobileDeviceUsed &&
            this.teaserAlignment != "left" &&
            <Fragment>
              {this.getImageDom()}
              {this.getMarqueeContentDom()}
            </Fragment>
          }{!this.isMobileDeviceUsed &&
            this.teaserAlignment == "left" &&
            <Fragment>
              {this.getMarqueeContentDom()}
              {this.getImageDom()}
            </Fragment>
          }
          {
            this.isMobileDeviceUsed &&
            <Fragment>
              {this.getImageDom()}
              {this.getMarqueeContentDom()}
            </Fragment>
          }
        </div>
      </div>
    );
  }
}
